import { Injectable } from '@angular/core';
import { XAPIDataGenerator } from 'libs-frontend-xapi/dist/js/xapidatagenerator.js';
import { ImgBookHelperService } from './img-book-helper.service';
import { nanoid } from 'nanoid';
import { XAPIHelperService } from './xAPI-helper.service';
import { HttpClient } from '@angular/common/http';
import { ApiGatewayHelperService } from 'modules/app/services/apigateway-helper.service';
import { Subject } from 'rxjs';
import { environment } from 'environments/environment';
import DesktopConfig from 'modules/desktop/services/config';
import { DesktopEBookVMService } from 'modules/desktop/services/desktop-ebook-vm.service';
import { StudentBookService } from './student-book.service';

// stringified empty array
const EMPTY_ARRAY_STRING = "[]";
@Injectable()
export class DrawingDataService {
    drawingData: any;
    callWaiting = false;
    timer: any;
    pageObj = {};
    priorRoute;
    pageLayout: any;
    xAPIPostDelay = 5000;
    studentBookId: string;
    userId: string
    spaceId: string;
    pageLabel:string;
    // object to hold data which was fetched fropm server and the data which was latest posted to server
    priorData:any = [];
    // actions possible on a drawing
    dataActions = {
        DELETED: "deleted",
        SAVED: "saved"
    }

    // structure of cache
    // _drawingCache = {
    //     // unique identifies is created using some combination of userid-bookcode-pageLabel
    //     // dev_test_my_audio_video_book-3b69f9dc18fa44fc82050b31e42d37bb-16
    //     uniqueIdentifier1 : {
    //             // actual drawings data in json format.
    //     }
    // }


    private _drawingCache = {};     // to store/ cache drawings fetched from server.
    private _pendingCallsQueue = [];    // to store details of all the calls sent to server to prevent duplicate send.
    private _fetchedQueue = [];     // queue to store the order in which the drawings were fetched. To flush out older caches.
    private _maxNumberOfCacheAllowed = 15;      // to store the max value of cached entries allowed.
    private _drawingDataToUniqueIDMap = {};     // to store the unique id stored on server corresponding to the book-user-page combination.
    private _toasterReference;
    private _errorToastCounter = 0;
    private _timeToWaitBeforeCaching = 4000;
    private _cacheCallTimeoutReference = undefined;
    private _fibonacciNumberUno = 1;
    private _fibonacciNumberDos = 1;
    private _backgroundRetryOngoing = false;
    private _backgroundRetryMaxCount = 7;
    private _backgroundRetryTimerReference;
    private _backgroundDrawingRetryResponseNotifier = new Subject<any>();
    backgroundDrawingRetryResponseObservable$ = this._backgroundDrawingRetryResponseNotifier.asObservable();

    private _toastId;

    constructor(
        private imgBookHelperService: ImgBookHelperService,
        private xAPIHelperService: XAPIHelperService,
        private apiGatewayHelperService: ApiGatewayHelperService,
        private http: HttpClient,
        private desktopEBookVMService: DesktopEBookVMService,
        private studentBookService: StudentBookService,
    ) { }

    setUserData(userId, bookCode, spaceId){
        this.userId = userId;
        this.studentBookId = bookCode;
        this.spaceId = spaceId;
    }

    // fetches page layout on page load
    // and set it in a class variable
    setPageLayout() {
        this.pageLayout = this.imgBookHelperService.getCurrentPageLayout();
    }
    
    /* Fetching drawing data from local storage */
    getDrawingDataFromLocalStorage() {
        return JSON.parse(localStorage.getItem('drawingDataInLocalStorage'));
    }

    /**
     * Using drawing data and creating custom statement to be posted to the xAPI
     * @param action 
     * @returns : [customStatement]
     */
    createCustomStatement(action?) {
        let customStatementArr = [];
        let uniqueId;
        let options = {};
        let localDrawingsData = this.getDrawingDataFromLocalStorage();
        if (this.pageLayout === 'single') {

            let pageId = localDrawingsData && Object.keys(localDrawingsData)[0];

            if (action == this.dataActions.DELETED) {
                this.priorData.splice(this.priorData.indexOf(this.pageLabel), 1);
                this._setDrawingsToCache({data:EMPTY_ARRAY_STRING}, this.studentBookId, this.userId, this.pageLabel)

                options = {
                    'user_data': this.drawingData.user_data
                }
                uniqueId = "" + this.drawingData.user_data.documentid
            }else {
                options = {
                    'user_data': localDrawingsData[pageId]
                }
                uniqueId = "" + localDrawingsData[pageId].documentid;
                // this.priorData[this.pageLabel] = localDrawingsData && localDrawingsData[pageId].payload.data;
                if(localDrawingsData){
                    this.setPageData(this.pageLabel);
                    this._setDrawingsToCache(JSON.parse(localDrawingsData[pageId].payload), this.studentBookId, this.userId, pageId)
                }
            }
            // generate custom statement
            let customStatement = XAPIDataGenerator.generateCustomStatement(uniqueId, 'annotated', options);
            
            customStatementArr.push({id: uniqueId, statement: customStatement, userData: this.drawingData.user_data});

        } else {//DOUBLE CASES
            let data
            if (action == this.dataActions.DELETED) {
                
                data = this.pageObj;

                this.priorData.splice(this.priorData.indexOf(this.pageLabel), 1);
                this._setDrawingsToCache({data:EMPTY_ARRAY_STRING}, this.studentBookId, this.userId, this.pageLabel);

            }
            else {
                data = localDrawingsData;

                for (let i in data) {
                    // this.priorData[i] = data[i] && data[i].payload && JSON.parse(data[i].payload).data;
                    if(data[i] && data[i].payload){
                        this.setPageData(i);
                        this._setDrawingsToCache(JSON.parse(data[i].payload), this.studentBookId, this.userId, i);
                    }
                }
            }
            for (let i in data) {
                let drawingOptions = {
                    'user_data': data[i]
                }
                // this.priorData[i] = data[i] && data[i].payload;

                uniqueId = "" + data[i].documentid;
                
                let customStatement = XAPIDataGenerator.generateCustomStatement(uniqueId, 'annotated', drawingOptions);
                customStatementArr.push({id: uniqueId, statement: customStatement, userData: data[i]});
            }
        }

        return customStatementArr;
    }

    /**
     * setting page's drawing data on pageload
     * @param data 
     * @param pageLabel 
     */
    setPageData(pageLabel) {
        pageLabel = ""+pageLabel;
        if(this.priorData.indexOf(pageLabel) == -1){
            this.priorData.push(pageLabel);
        }
    }

    postStatmentToXAPI(customStatements) {

        let isVMAvailable = this.desktopEBookVMService.getActiveVM();

        customStatements.forEach(({ id, statement, userData }) => {
            // post custom tatement to xAPI
            this.callWaiting = false;
            this.drawingData.isNewlyCreated = false;
            /* let xapiLOAnalytics = this.xAPIHelperService.getXAPIAnalyticsObject();
            await xapiLOAnalytics.postStatements(statement); */

            if (isVMAvailable) {
                this.desktopEBookVMService.addNewDirtyRecord(DesktopEBookVMService.USER_DATA_TYPE.DRAWINGS, { id, statement, userData });
            } else {
                this.xAPIHelperService.postStatmentToXAPI(id, statement)
            }
        });

        localStorage.removeItem('drawingDataInLocalStorage');
        this.pageObj = {};
    }

    /**
     * This method receives the drawing data for a page from student book
     * does operation based on user action (add/ edit/ delete)
     * @param data : drawing data array
     * @param pageLabel : page pageLabelLabel
     */
    async saveDrawingData(data, serial) {
        this.pageLabel = this.imgBookHelperService.getPageLabelByPageSerial(serial);

        let documentid = this.getUniqueId(this.studentBookId, this.userId, this.pageLabel);
        this.drawingData = {
            "identifier": this.pageLabel,
            "isNewlyCreated": true,
            "user_data": {
                "documentid": documentid,
                "folderid": this.studentBookId + '/annotation/p_' + this.pageLabel + '/',
                "action": JSON.parse(data).length ? 'create' : 'delete',
                "type": 'annotation',
                "payload": JSON.stringify({
                    "data": data
                })
            }
        }
        this.pageObj[this.drawingData.identifier] = this.drawingData.user_data;

        if (this.drawingData.user_data.action === 'delete')//Handles delete case for both layout
        {
            if(this.priorData.indexOf(this.pageLabel) != -1){
                //post local data
                this.timer && clearTimeout(this.timer);
                this.postStatmentToXAPI(this.createCustomStatement(this.dataActions.DELETED));
                this.deleteUniqueId(this.studentBookId, this.userId, this.pageLabel);
                await this.xAPIHelperService.flushStateAndStatement();
            }
            else {

                this.timer && clearTimeout(this.timer);
                this.callWaiting = false;
                localStorage.removeItem('drawingDataInLocalStorage');

                /* if (!this.callWaiting) {
                    this.postStatmentToXAPI(this.createCustomStatement(this.dataActions.DELETED));
                }

                else {
                    this.timer && clearTimeout(this.timer);
                    localStorage.removeItem('drawingDataInLocalStorage')
                } */
            }
        }
        else {//Handles create case for both layout
            let pageData = this.pageObj;
            localStorage.setItem('drawingDataInLocalStorage', JSON.stringify(pageData));
            this.postDrawingData(true);
        }
    }

    postDrawingData(batching?) {
        
        if (batching) {
            if (!this.callWaiting) {
                this.callWaiting = true;
                this.timer = setTimeout(() => {
                    /* delaying xAPI call for 5 secs*/
                    this.postStatmentToXAPI(this.createCustomStatement(this.dataActions.SAVED));
                }, this.xAPIPostDelay);
            }
        }
        else {
            let hasLocalData = this.getDrawingDataFromLocalStorage();
            /* triggering xAPI to post immediately*/
            this.timer && clearTimeout(this.timer)
            hasLocalData && this.postStatmentToXAPI(this.createCustomStatement(this.dataActions.SAVED));
        }
    }

    /************************************
    * Exposed Public Functions
    ************************************/

    // DEPRECATED FUNCTIONS FOR THE TIME BEING.
    // function to get drawings of a given page and cache nearby pages' drawings.
    // public async getDrawingsWithCache(bookCode, userId, pageSerial) {
    //     let pageLabel = this.imgBookHelperService.getPageLabelByPageSerial(pageSerial);
    //     this._cacheNearByDrawings(bookCode, userId, pageLabel);
    //     return await this.getDrawingsWithoutCache(bookCode, userId, pageSerial);
    // }

    // function to get drawings of a given page without caching other pages.
    // public async getDrawingsWithoutCache(bookCode, userId, pageSerial) {
    //     let pageLabel = this.imgBookHelperService.getPageLabelByPageSerial(pageSerial);
    //     return await this._getDrawings(bookCode, userId, pageLabel);
    // }

    // function to empty the drawing cache. For ebook toggle.
    public emptyDrawingCache() {
        this._drawingCache = {};
    }

    // get the unique id for book-user-page commbination in the map.
    // if id not found, generate a new id, set and return.
    public getUniqueId(bookCode, userId, pageLabel) {

        let uid = this._drawingDataToUniqueIDMap[bookCode + '-' + userId + '-' + pageLabel];
        if (!uid) {
            uid = nanoid(16);
            this._setUniqueId(bookCode, userId, pageLabel, uid);
        }
        return uid;

    }

    public deleteUniqueId(bookCode, userId, pageLabel) {
        delete this._drawingDataToUniqueIDMap[bookCode + '-' + userId + '-' + pageLabel];
    }

    public setToasterReference(reference) {
        this._toasterReference = reference;
    }

    public getPendingCallStatus(bookCode, userId, pageLabel) {
        if (this._pendingCallsQueue.indexOf(bookCode + '-' + userId + '-' + pageLabel) >= 0) {
            return true;
        }
        return false;
    }

    public resetToastCounter() {
        this._errorToastCounter = 0;
    }

    /************************************
    * Private Functions
    ************************************/

    // if in single page view such that we are on page 116 we will send a fetch call for pages 111 to 121 moving outward from 116.
    // if we are in double page view such that we are on page 116-117 we will send a fetch call from 116-117 
    // to 111 to 121 moving outward from 116.
    // for each fetch call we will cache the data in memory and a fetch call wont be necessary if we have data in memory.
    // private _cacheNearByDrawings(bookCode, userId, pageLabel) {
    //     // get drawings from api if not present in intervals. intervals are used to not send 10 requests to api at once.
    //     for (let i = 1; i <= 5; i++) {
    //         setTimeout(() => {
    //             this._getDrawings(bookCode, userId, pageLabel + i);
    //             this._getDrawings(bookCode, userId, pageLabel - i);
    //         }, i * 1000);
    //     }
    // }

    // return drawings is already present in cache.
    private _getDrawingsFromCache(bookCode, userId, pageLabel) {
        let key = bookCode + '-' + userId + '-' + pageLabel;
        let data = this._drawingCache[key];
        return data;
    }

    // return drawings is already present in cache.
    /**
     * data: {data: "<strngified-array-of-lines>"}
     */
    private _setDrawingsToCache(data, bookCode, userId, pageLabel) {
        let key = bookCode + '-' + userId + '-' + pageLabel;
        if(data){
            this._drawingCache[key] = data;
        }else{
            delete this._drawingCache[key];
        }
    }


    // function to get drawings via a fetch call from api.
    // we store which calls have already been sent and awaiting response so that we do not send same call again.
    private async _getDrawingsFromServer(bookCode, userId, pageLabel, retryAttempt) {

        try {

            // if call exists, return
            if (this.getPendingCallStatus(bookCode, userId, pageLabel)) {
                return;
            }
            

            // add fetch call to calls array.
            this._pendingCallsQueue.push(bookCode + '-' + userId + '-' + pageLabel);
            
            let drawingResponse:any = await this.http.get(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + 'getDrawings/' + bookCode + '/' + userId + '/' + pageLabel).toPromise();

            // remove call from calls array.
            if (this._pendingCallsQueue.indexOf(bookCode + '-' + userId + '-' + pageLabel) >= 0) {
                this._pendingCallsQueue.splice(this._pendingCallsQueue.indexOf(bookCode + '-' + userId + '-' + pageLabel), 1);
            }

            // If we get drawings from server successfully.
            if(drawingResponse && drawingResponse.entities && drawingResponse.entities.length > 0) {

                let entities  = drawingResponse.entities;
                let drawingEntity = this._findEntityOfGivenPage(entities, pageLabel);

                if(!drawingEntity) {
                    return {data:EMPTY_ARRAY_STRING};
                }

                // TODO: return/set appropriate data from drawings object
                let drawingJson = JSON.parse(drawingEntity.data);

                // set recieved drawings in memory cache.
                this._drawingCache[bookCode + '-' + userId + '-' + pageLabel] = drawingJson;
                this._flushOlderDrawingsFromCache(bookCode, userId, pageLabel, false);
                this._setUniqueId(bookCode, userId, pageLabel, drawingEntity.documentid);

                // TODO : SEPERATE CODE FOR SUCCESS AND FAILURE.
                // TODO : ADD RETRY LOGIC IN CASE OF FAILURE.

                return drawingJson;

            } else if(drawingResponse && drawingResponse.entities && drawingResponse.entities.length == 0) {
                // if the data is empty, i.e. no drawings on server.

                return {data:EMPTY_ARRAY_STRING};

            } else {
                // in case of error

                // retry logic

                if(retryAttempt % 3 == 0) {
                    this._errorToastCounter++;
                    return {data:EMPTY_ARRAY_STRING, status: "error"};
                }
                await this._sleep(2000);
                return this._getDrawingsFromServer(bookCode, userId, pageLabel, retryAttempt + 1);

            }
        }
        catch(error) {


            // remove call from calls array.
            if (this._pendingCallsQueue.indexOf(bookCode + '-' + userId + '-' + pageLabel) >= 0) {
                this._pendingCallsQueue.splice(this._pendingCallsQueue.indexOf(bookCode + '-' + userId + '-' + pageLabel), 1);
            }

            if(retryAttempt % 3 == 0) {
                
                this._errorToastCounter++;
                return {data:EMPTY_ARRAY_STRING, status: "error"};
            }

            await this._sleep(2000);
            return this._getDrawingsFromServer(bookCode, userId, pageLabel, retryAttempt + 1);

        }

    }

    private async _getDrawings(bookCode, userId, pageLabel) {
        // checks for valid bookcode, userid and pageLabel
        if (!bookCode || !userId || !pageLabel) {
            return;
        }

        // check if drawings already exists in cache.
        let drawingData = this._getDrawingsFromCache(bookCode, userId, pageLabel);

        if (!drawingData) {
            drawingData = await this._getDrawingsFromServer(bookCode, userId, pageLabel, 1);
        }

        // check unsaved data if there is no pending server call
        // this check executes after the server calls have been made
        // meaning that unsaved data is fetched only after server calls have completed
        if (!this.getPendingCallStatus(bookCode, userId, pageLabel)) {
            let unsavedData = this.updateForUnsavedData(bookCode, userId, pageLabel);
            if(unsavedData && unsavedData.data){
                drawingData = unsavedData;
            }
        }

        if(drawingData && drawingData.data && drawingData.data != EMPTY_ARRAY_STRING){
            this.setPageData(pageLabel);
        }

        return drawingData;

    }

    /**
     * Method for fetching unsaved drawing data
     */
    private updateForUnsavedData(bookCode, userId, pageLabel){
        try{
            let folderId = bookCode + '/annotation/p_' + pageLabel + '/';
            let data = this.xAPIHelperService.getUnsavedDataByFolderId(folderId, userId);
            
            if(data && data.length){
                // taking out last node as only last entry sent to xAPI is valid for drawings
                data = data[data.length - 1];
    
                // no different handling needed based on data.action
                // because in case of delete the data node is stringified empty array
                let res = {data: JSON.parse(data["payload"])["data"]};
                
                // setting unsaved data to the drawings cache
                this._setDrawingsToCache(res, bookCode, userId, pageLabel);

                return res; 
            }
            
        }catch(e){
            // do nothing as in case of error in fetching unsaved data 
            console.log("Error in calculating unsaved data, error: ", e);
        }
    }

    private _flushOlderDrawingsFromCache(bookCode, userId, pageLabel, pushAtStart = false) {


        let index = this._fetchedQueue.indexOf(bookCode + '-' + userId + '-' + pageLabel);
        if(index > -1 && !pushAtStart) {
            this._fetchedQueue.splice(index,1);
            this._fetchedQueue.push(bookCode + '-' + userId + '-' + pageLabel);
            return;
        }

        // the array excedes max allowed remove the oldest entry from cache.
        if (this._fetchedQueue.length > this._maxNumberOfCacheAllowed) {
            let id = this._fetchedQueue.shift();
            delete this._drawingCache[id];
        }

        // add newly fetched data.
        if(pushAtStart) {
            this._fetchedQueue.unshift(bookCode + '-' + userId + '-' + pageLabel);
        } else {
            this._fetchedQueue.push(bookCode + '-' + userId + '-' + pageLabel);
        }

    }

    // set the unique id for book-user-page commbination in the map.
    private _setUniqueId(bookCode, userId, pageLabel, id) {
        this._drawingDataToUniqueIDMap[bookCode + '-' + userId + '-' + pageLabel] = id;
    }

    private _sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    checkPendingDataInLocalStorage(){
        return this.getDrawingDataFromLocalStorage();
    }

    postPendingDrawingsToXAPI(){
        let hasLocalData = this.getDrawingDataFromLocalStorage();
        /* triggering xAPI to post immediately*/
        this.timer && clearTimeout(this.timer)
        hasLocalData && this.postStatmentToXAPI(this.createCustomStatement());
    }

    _findEntityOfGivenPage(entities, pageLabel) {
        if(!entities || !pageLabel) {
            return;
        }

        let drawingEntity = entities.find((entity) => { return entity.folderid.split('/').indexOf('p_'+pageLabel) > -1 });
        return drawingEntity;

    }

    async fetchMultipleDrawings(bookCode, userId, arrayOfPageSerials, retryAttempt) {

        let that = this;
        let arrayOfLabelsSuperSet = arrayOfPageSerials.map(page => { return that.imgBookHelperService.getPageLabelByPageSerial(page) });
        let arrayForLabelsRequiringFreshServerCall = [];

        arrayOfLabelsSuperSet.forEach(label => {
            // if call exists, return
            if (this.getPendingCallStatus(bookCode, userId, label)) {
                return;
            }
            if (!this._getDrawingsFromCache(bookCode, userId, label)) {
                arrayForLabelsRequiringFreshServerCall.push(label);
                this._pendingCallsQueue.push(bookCode + '-' + userId + '-' + label);
            }
        });
        
        let data = {
            bookCode: bookCode,
            userId: userId,
            arrayOfLabels: arrayForLabelsRequiringFreshServerCall
        }
        try {

            let drawingResponse;
            if (data.arrayOfLabels.length > 0) {

                this._toastId = this._toastId || this._toasterReference.showToast({ type: "load-drawings" });
                // Assuming that the response will be in same order the array was passed. If there is an error with order, then sort.
                drawingResponse = await this._fetchDrawings(data);
                this._backgroundRetryOngoing = false;

                this._toasterReference.clearToast(this._toastId);
                this._toastId = undefined;
                this.resetBackgroundRetryAttempts(true);
            } else {

                this._backgroundRetryOngoing = false;
                
                // handling for scenerio when data is being fetched and fetch was called again.
                if(!this._checkIfAllPagesAreAwaitingFetchCall(bookCode, userId, arrayOfLabelsSuperSet)) {
                    return {data:EMPTY_ARRAY_STRING, status: "pendingFetch",  enableDrawing : false};
                }

                let finalDrawingObject1 = {};
                arrayOfLabelsSuperSet.forEach(label => {

                    let serial = that.imgBookHelperService.getPageSerialByPageLabel(label);

                    let drawingData = this._getDrawingsFromCache(bookCode, userId, label);
                    if (!drawingData) {
                        drawingData = { data: EMPTY_ARRAY_STRING };
                    } else {
                        this._flushOlderDrawingsFromCache(bookCode, userId, label, false);
                    }

                    finalDrawingObject1[serial] = drawingData;

                });

                // send a cache call to debouncer
                this._cacheNearByDrawingsDebouncer(bookCode, userId, arrayOfPageSerials);
                this.resetBackgroundRetryAttempts(true);

                return finalDrawingObject1;

            }

            // send a cache call to debouncer
            this._cacheNearByDrawingsDebouncer(bookCode, userId, arrayOfPageSerials);

            // need handling for no response and for error
            let finalDrawingObject = {};
            arrayOfLabelsSuperSet.forEach(label => {

                // remove call from calls array.
                if (this._pendingCallsQueue.indexOf(bookCode + '-' + userId + '-' + label) >= 0) {
                    this._pendingCallsQueue.splice(this._pendingCallsQueue.indexOf(bookCode + '-' + userId + '-' + label), 1);
                }

                let serial = that.imgBookHelperService.getPageSerialByPageLabel(label);

                let drawingData = this._getDrawingsFromCache(bookCode, userId, label);
                let drawingEntity;
                if (!drawingData) {

                    if (drawingResponse[arrayForLabelsRequiringFreshServerCall.indexOf(label)].entities.length > 0) {
                        drawingEntity = drawingResponse[arrayForLabelsRequiringFreshServerCall.indexOf(label)].entities[0];
                        drawingData = JSON.parse(drawingEntity.data);
                        this._flushOlderDrawingsFromCache(bookCode, userId, label, false);
                        this._setUniqueId(bookCode, userId, label, drawingEntity.documentid);
                        if (drawingData && drawingData.data && drawingData.data != EMPTY_ARRAY_STRING) {
                            this.setPageData(label);
                        }
                    } else {
                        // handle in case some error is sent from server.
                        drawingData = { data: EMPTY_ARRAY_STRING };
                    }

                    that._setDrawingsToCache(drawingData, bookCode, userId, label);

                }

                finalDrawingObject[serial] = drawingData;

            });

            return finalDrawingObject;
        }
        catch(error) {

            arrayOfLabelsSuperSet.forEach(label => {

                // remove call from calls array.
                if (this._pendingCallsQueue.indexOf(bookCode + '-' + userId + '-' + label) >= 0) {
                    this._pendingCallsQueue.splice(this._pendingCallsQueue.indexOf(bookCode + '-' + userId + '-' + label), 1);
                }

            });

            await this._sleep(retryAttempt * 1000);
            
            if(retryAttempt > 4) {
                
                this._toastId && this._toasterReference.clearToast(this._toastId);
                this._toastId = undefined;
                await this._sleep(500);
                this._toasterReference.showToast({ type: "failed-load-drawings" });
                // this._startBackgroundRetryAttempts(bookCode, userId, arrayOfPageSerials, 1);
                return {data:EMPTY_ARRAY_STRING, status: "error"};
            }

            return this.fetchMultipleDrawings(bookCode, userId, arrayOfPageSerials, retryAttempt + 1);
        }

    }

    _checkIfAllPagesAreAwaitingFetchCall(bookCode, userId, arrayOfLabels) {
        
        let tempArray = [];
        arrayOfLabels.forEach(label => {
            if(!this.getPendingCallStatus(bookCode, userId, label)) {
                tempArray.push(label);
            }
        });
        return tempArray.length > 0

    }

    /**
     * function to debounce / limit the number or calls made to cache drawings for nearby pages.
     * @param bookCode - student book code used to fetch and set drawings.
     * @param userId - user id used to fetch and set drawings.
     * @param arrayOfPageSerials - array of serials used to find nearby labels.
     * every fresh call clears the old timeout function and creates a new timeout function.
     * only the last call is honoured.
     * time for a timeout function is 5000ms.
     */
    _cacheNearByDrawingsDebouncer(bookCode, userId, arrayOfPageSerials) {

        if(this._cacheCallTimeoutReference) {
            clearTimeout(this._cacheCallTimeoutReference);
            this._cacheCallTimeoutReference = undefined;
        }

        this._cacheCallTimeoutReference = setTimeout( () => {
            this._cacheNearByDrawings(bookCode, userId, arrayOfPageSerials);
            clearTimeout(this._cacheCallTimeoutReference);
            this._cacheCallTimeoutReference = undefined;
        },this._timeToWaitBeforeCaching);

    }


    /**
     * function to fetch drawings of nearby pages and cache them
     * @param bookCode - student book code used to fetch and set drawings.
     * @param userId - user id used to fetch and set drawings.
     * @param arrayOfPageSerials - array of serials used to find nearby labels.
     * get nearby page labels, send api call to fetch data, set data in cache.
     */
    // TODO : check if for slow network connection calls are being sent multiple times, if yes then create a cache pending queue.
    async _cacheNearByDrawings(bookCode, userId, arrayOfPageSerials) {

        // get array of labels for which drawings are to be cached.
        let nearbyLabels = this._getNearbyPageLabels(bookCode, userId, arrayOfPageSerials);

        // do not send a fetch call if all there are no pages to fetch.
        if(nearbyLabels.length == 0) {
            return;
        }
        
        // data required for post call.
        let data = {
            bookCode: bookCode,
            userId: userId,
            arrayOfLabels: nearbyLabels
        }

        try {

            // fetch api call.
            let drawingResponses:any = await this._fetchDrawings(data);

            // purge a chunk of fetched queue as we would be inserting from start
            if(this._fetchedQueue.length + drawingResponses.length > this._maxNumberOfCacheAllowed) {
                let deletedPages = this._fetchedQueue.splice(0, this._fetchedQueue.length + drawingResponses.length - this._maxNumberOfCacheAllowed);
                deletedPages.forEach(page => {
                    delete this._drawingCache[page];
                });
            }

            drawingResponses.forEach( (response,index) => {

                let label = nearbyLabels[index];
                let drawingData;

                // if the current pagelabel has drawings.
                if(response.entities.length > 0) {

                    let drawingEntity = response.entities[0];
                    drawingData = JSON.parse(drawingEntity.data);

                    // set unique id
                    this._setUniqueId(bookCode, userId, label, drawingEntity.documentid);

                } else {
                    drawingData = { data: EMPTY_ARRAY_STRING };
                }
                
                // remove previously cached drawings.
                this._flushOlderDrawingsFromCache(bookCode, userId, label, true);

                // if drawing response was not null, then set page data.
                if (drawingData && drawingData.data && drawingData.data != EMPTY_ARRAY_STRING) {
                    this.setPageData(label);
                }

                // save fetched data to cache.
                this._setDrawingsToCache(drawingData, bookCode, userId, label);
                
            });

        }
        catch(error) {
            console.log(error);
        }
                


    }

    /**
     * function that takes in an array of page serials and return all valid nearby page labels.
     * @param bookCode - student book code used to check if a page's drwaings already exists in cache.
     * @param userId - user id used to check if a page's drwaings already exists in cache.
     * @param arrayOfPageSerials - array of serials used to find nearby labels.
     * filters out pages that are duplicate, already exists in cache or are passed as parametes.
     * return 2 pages left, 4 right and any jump to page hotspot page of given pages.
     */
    _getNearbyPageLabels(bookCode, userId, arrayOfPageSerials) {

        let arrayOfNearbyLabels = [];
        let numberOfPreviousCachedPages = 2;
        let numberOfNextCachedPages = 4;
        let that = this;

        // convert array of page serials to respoective labels
        let arrayOfPageLabels = arrayOfPageSerials.map(page => { return that.imgBookHelperService.getPageLabelByPageSerial(page) });

        // get list of all units in the book.
        let units = this.imgBookHelperService.getUnits();
        let labelsArray = [];

        // add all the labels to an array.
        Object.keys(units).forEach(unit => {
            units[unit].items.forEach(item => {
                labelsArray.push(item.label);
            });
        });

        // maintain this fetch order [Next Pages, Previous Pages, Jump to page hotspot pages];
        // push all the nearby NEXT page labels in an array.
        arrayOfPageLabels.forEach(page => {
            let pageIndex = labelsArray.indexOf(page);
            for(let i=0; i<=numberOfNextCachedPages; i++) {
                if( pageIndex + i < labelsArray.length ) {
                    arrayOfNearbyLabels.push(labelsArray[pageIndex + i]);
                }
            }
        });

        // push all the nearby PREVIOUS page labels in an array.
        arrayOfPageLabels.forEach(page => {
            let pageIndex = labelsArray.indexOf(page);
            for(let i=numberOfPreviousCachedPages; i>=0; i--) {
                if( pageIndex - i >= 0 ) {
                    arrayOfNearbyLabels.push(labelsArray[pageIndex - i]);
                }
            }
        });

        // add pages for hotspots if any TO THE START OF ARRAY.
        let hotspotJSON = this.imgBookHelperService.getOverlayJSON();
        if(hotspotJSON) {
            arrayOfPageSerials.forEach(serial => {
                let hotspotArray = hotspotJSON[serial];
                if(hotspotArray) {
                    hotspotArray.forEach(hotspot => {
                        if(hotspot.type == 'page') {
                            if(hotspot['page'] && hotspot['page'].pagelabel && hotspot['page'].pagelabel != undefined) {
                                arrayOfNearbyLabels.push(hotspot['page'].pagelabel);
                            }
                        }
                    });
                }
            });
        }

        // filter out page labels that are duplicate.
        // filter out page labels whose drawings are already in cache.
        // filter out page labels that are passed as parameter to this function.
        arrayOfNearbyLabels = arrayOfNearbyLabels.filter((label, index) => {
            return (arrayOfNearbyLabels.indexOf(label) === index) && 
            (!this._drawingCache.hasOwnProperty(bookCode + '-' + userId + '-' + label)) &&
            arrayOfPageLabels.indexOf(label) == -1;
        });

        return arrayOfNearbyLabels;
    }

    _getNextFibonacciValue() {
        this._fibonacciNumberDos = this._fibonacciNumberUno + this._fibonacciNumberDos;
        this._fibonacciNumberUno = this._fibonacciNumberDos - this._fibonacciNumberUno;
        return this._fibonacciNumberUno + this._fibonacciNumberDos;
    }

    _resetFibonacciSeries() {
        this._fibonacciNumberUno = 1;
        this._fibonacciNumberDos = 1;
    }

    resetBackgroundRetryAttempts(resetTimer = true) {
        clearTimeout(this._backgroundRetryTimerReference);
        this._backgroundRetryTimerReference = undefined;
        if(resetTimer) {
            this._resetFibonacciSeries();
        }
    }

     _startBackgroundRetryAttempts(bookCode, userId, arrayOfPageSerials, retryAttemptCount) {

        if(retryAttemptCount > this._backgroundRetryMaxCount) {
            this.resetBackgroundRetryAttempts(true);
            return;
        }

        // create the data required to make a server call.
        let that = this;
        // map all page serials with page labels.
        let arrayOfPageLabels = arrayOfPageSerials.map(pageSerial => { return that.imgBookHelperService.getPageLabelByPageSerial(pageSerial) });
        // filter out page labels that are in cache.
        arrayOfPageLabels = arrayOfPageLabels.filter(pageLabel => { return that._getDrawingsFromCache(bookCode, userId, pageLabel) == undefined });

        if(arrayOfPageLabels.length == 0) {
            return;
        }

        let data = {
            bookCode: bookCode,
            userId: userId,
            arrayOfLabels: arrayOfPageLabels
        }

        
        // remove old timer if exists
        if(this._backgroundRetryOngoing) {
            this.resetBackgroundRetryAttempts(true);
        }
        this._backgroundRetryOngoing = true; 

        let timerValue = this._getNextFibonacciValue();

        this._backgroundRetryTimerReference = setTimeout( async () => {

            // check if data is recieved from server,
            // if yes create an event and send to FE.
            // if no retry.
            if(navigator.onLine) {
                try {
                    let drawingResponse = await this._fetchDrawings(data);
                    if(drawingResponse) {
                        this._dataRecievedFromRetryAttempt(bookCode, userId, arrayOfPageSerials, arrayOfPageLabels, drawingResponse);
                        this.resetBackgroundRetryAttempts(true);
                        this._cacheNearByDrawingsDebouncer(bookCode, userId, arrayOfPageSerials);
                    } else {
                        this.resetBackgroundRetryAttempts(false);
                        this._startBackgroundRetryAttempts(bookCode, userId, arrayOfPageSerials, retryAttemptCount + 1);
                    }
                }
                catch(error) {
                    console.log(error);
                    this.resetBackgroundRetryAttempts(false);
                    this._startBackgroundRetryAttempts(bookCode, userId, arrayOfPageSerials, retryAttemptCount + 1);
                }
            } else {
                this.resetBackgroundRetryAttempts(false);
                this._startBackgroundRetryAttempts(bookCode, userId, arrayOfPageSerials, retryAttemptCount + 1);
            }

        },timerValue*1000);

    }

    _dataRecievedFromRetryAttempt(bookCode, userId, arrayOfPageSerials, arrayOfPageLabels, drawingResponse) {
        let outputResponse = {};
        drawingResponse && drawingResponse.forEach( (response,index) => {

            let label = arrayOfPageLabels[index];
            let drawingData;

            // if the current pagelabel has drawings.
            if(response.entities.length > 0) {

                let drawingEntity = response.entities[0];
                drawingData = JSON.parse(drawingEntity.data);

                // set unique id
                this._setUniqueId(bookCode, userId, label, drawingEntity.documentid);
                outputResponse[label] = drawingData;

            } else {
                drawingData = { data: EMPTY_ARRAY_STRING };
            }
            
            // remove previously cached drawings.
            this._flushOlderDrawingsFromCache(bookCode, userId, label, false);

            // if drawing response was not null, then set page data.
            if (drawingData && drawingData.data && drawingData.data != EMPTY_ARRAY_STRING) {
                this.setPageData(label);
            }

            // save fetched data to cache.
            this._setDrawingsToCache(drawingData, bookCode, userId, label);
            
        });
        this._backgroundDrawingRetryResponseNotifier.next(outputResponse);
    }

    async _fetchDrawings(data){
        let baseURL = this.apiGatewayHelperService.getApiGatewayPrefixUrl();

        if(environment.isDesktopApp){
            baseURL = DesktopConfig.app.api.baseUrl + baseURL;
        }

        if (this.desktopEBookVMService.getActiveVM()) {

            let drawingData = this.desktopEBookVMService.getLocalData().drawingsData;


            let dataToBeReturned = [];
            data.arrayOfLabels.forEach(label => {
                // create a folder id to filter out drawings of current page.
                let folderId = `${data.bookCode}/annotation/p_${label}/`;

                // filter out drawings of current page.
                let drawingsWithCurrentLabel = drawingData.filter((dData) => { return dData.folderId == folderId });
                

                // filter out drawings that are not marked to be deleted.
                let drawingsWithCurrentLabelWithoutDelete = drawingsWithCurrentLabel.filter((dData) => { 
                    if(!dData) return false;
                    if(dData && !dData.dirty) return true;
                    if(dData && dData.dirty && dData.dirty.userAction == 'delete') return false;
                    return true;
                });

                let foundData;
                // find the latest drawing based on timestamp
                drawingsWithCurrentLabelWithoutDelete.forEach(drawingObj => {
                    if( !foundData || foundData && foundData.timestamp < drawingObj.timestamp) {
                        foundData = drawingObj;
                    }
                });

                // if a drawing is found that matches all the filters then return that, else return empty object.
                if (foundData) {

                    dataToBeReturned.push({
                        entities: [{
                            documentid: foundData.documentId.substring(3),
                            data: foundData.data,
                            folderid: foundData.folderId
                        }]
                    });
                } else {
                    dataToBeReturned.push({
                        entities: []
                    })
                }

            });
            
            this._backgroundRetryOngoing = false;

            return dataToBeReturned;
        } else {
            if(environment.isDesktopApp && !this.studentBookService.isEbookInView){
                return;
            }

            let drawingData = await this.http.post(baseURL + 'fetchAnnotations', data).toPromise();
            this._backgroundRetryOngoing = false;
            return drawingData;
        }
        

    }

}
